module.exports = __webpack_public_path__ + "static/img/13.8db6cc95.jpg";